import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { api, mediaUrl } from '@/lib/api'
import { translations } from '@/lib/translations'

export default function BlogDetailPage({ language, setLanguage, theme, setTheme }) {
  const t = translations[language]
  const { slug } = useParams()
  const [post, setPost] = useState(null)

  useEffect(() => {
    api.get(`/blog/slug/${slug}`).then((res) => setPost(res.data.data)).catch(() => setPost(null))
  }, [slug])

  return (
    <div className="bg-background text-foreground min-h-screen">
      <Header
        language={language}
        toggleLanguage={() => setLanguage(language === 'en' ? 'am' : 'en')}
        isDarkMode={theme === 'dark'}
        toggleDarkMode={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      />
      <main className="pt-28 pb-16 px-4">
        <article className="max-w-3xl mx-auto">
          <Link to="/blog" className="text-primary text-sm mb-6 inline-block">{t.blog?.back || 'Back to news'}</Link>
          {post ? (
            <>
              {post.featuredImage && (
                <img src={mediaUrl(post.featuredImage)} alt="" className="w-full rounded-2xl mb-6 max-h-[420px] object-cover" />
              )}
              <p className="text-primary text-sm mb-2">{post.category}</p>
              <h1 className="text-4xl font-bold mb-4">{post.title}</h1>
              <p className="text-sm text-muted-foreground mb-8">{post.author} · {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString() : ''}</p>
              <div className="prose dark:prose-invert max-w-none" dangerouslySetInnerHTML={{ __html: post.content }} />
            </>
          ) : (
            <p className="text-muted-foreground">Article not found.</p>
          )}
        </article>
      </main>
      <Footer language={language} />
    </div>
  )
}
